var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { AppContext } from '../index';
var MapRow = function (_a) {
    var map = _a.map;
    var _b = __read(useState(false), 2), loadThumbnail = _b[0], setLoadThumbnail = _b[1];
    var ref = useRef(null);
    var navigate = useNavigate();
    var _c = __read(useState(''), 2), thumbnailSrc = _c[0], setThumbnailSrc = _c[1]; // State for thumbnail source
    var timerIdRef = useRef(null);
    var _d = useContext(AppContext), thumbnailCache = _d.thumbnailCache, setSelectedMap = _d.setSelectedMap, t = _d.t;
    useEffect(function () {
        var observer = new IntersectionObserver(function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            if (entry.isIntersecting) {
                // Start the timer when the component comes into view
                if (thumbnailCache.current[thumbnailUrl]) {
                    // If the thumbnail is already in cache, load immediately
                    setLoadThumbnail(true);
                    setThumbnailSrc(thumbnailUrl);
                }
                else {
                    // Start the timer when the component comes into view
                    timerIdRef.current = setTimeout(function () {
                        setLoadThumbnail(true);
                        setThumbnailSrc(thumbnailUrl);
                        thumbnailCache.current[thumbnailUrl] = true; // Store in cache
                    }, 750); // 750ms delay
                }
            }
            else {
                // If the component leaves the viewport, cancel the timer
                if (timerIdRef.current) {
                    clearTimeout(timerIdRef.current);
                    timerIdRef.current = null;
                }
            }
        }, {
            threshold: 0.1, // Adjust as needed
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
        // Clean up on unmount
        return function () {
            if (observer && ref.current) {
                observer.unobserve(ref.current);
            }
            if (timerIdRef.current) {
                clearTimeout(timerIdRef.current);
            }
        };
    }, []);
    // Format the lastModified date
    var lmformattedDate = new Date(map.lastModified).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    var formattedDate = new Date(map.created).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    var mapCode = DOMPurify.sanitize(map.mapCode);
    var date = new Date(map.lastModified);
    date.setSeconds(0);
    date.setMilliseconds(0);
    var thumbnailUrl = "https://www.scribblemaps.com/api/maps/images/".concat(mapCode, "_thumb_450x450.webp?d=").concat(date.getTime() / 1000);
    return (React.createElement("div", { ref: ref, className: 'mapRowContent' },
        React.createElement("div", { className: "thumbnail" }, loadThumbnail && (React.createElement("img", { src: thumbnailSrc, alt: DOMPurify.sanitize(map.title), onError: function () { return setLoadThumbnail(false); } }))),
        React.createElement("div", { className: "info" },
            React.createElement("div", { className: "title" }, DOMPurify.sanitize(map.title)),
            React.createElement("div", { className: "mapCode" },
                t('map_list.map_id'),
                ": ",
                mapCode),
            React.createElement("div", { className: "date" },
                t('map_list.date_created'),
                ": ",
                formattedDate),
            React.createElement("div", { className: "date" },
                t('map_list.date_modified'),
                ": ",
                lmformattedDate)),
        React.createElement("div", { className: "viewWrapper" },
            React.createElement("div", { className: "view", onClick: function () {
                    setSelectedMap(map);
                    navigate("/maps/view/".concat(map.mapCode));
                } }, t('map_list.open')))));
};
export default MapRow;
